import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import HostelDetails from './section-components/hotel-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const HotelManagement = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Hotel Management Courses In Chennai | Crafts, Degree/Diploma</title>
            <meta name="description" content="MIET offers Hotel Management Courses in Chennai. If you have a flair for Hospitality, find out more about our Degree, Diploma and Crafts courses." />
        </Helmet>
        <PageHeader headertitle="Hotel Management & Catering Technology"  />
        <HostelDetails />
        <Footer />
    </div>
}

export default HotelManagement